export const APPNAME = "NCJ"; 

